import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["pasteSection", "codeSection"];

  connect() {
    this.updateView();
  }

  select() {
    this.updateView();
  }

  updateView() {
    const selected = this.element.querySelector(
      'input[name="method"]:checked',
    )?.value;
    const isPaste = !selected || selected === "paste";

    this.pasteSectionTarget.classList.toggle("hidden", !isPaste);
    this.codeSectionTarget.classList.toggle("hidden", isPaste);
  }
}
